module.exports = __webpack_public_path__ + "assets/img/smartTV2-icon1.aae732e7.svg";